var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB515",
    d: "M35 17.5C35 27.177 27.177 35 17.5 35S0 27.177 0 17.5 7.824 0 17.5 0 35 7.824 35 17.5m-32.941 0A15.42 15.42 0 0 0 17.5 32.941 15.42 15.42 0 0 0 32.941 17.5 15.42 15.42 0 0 0 17.5 2.059 15.42 15.42 0 0 0 2.059 17.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB515",
    d: "M19.25 8.956 10.706 17.5l8.544 8.544-1.441 1.441L7.824 17.5l9.985-9.985z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB515",
    d: "M9.265 18.53v-2.06h17.5v2.06z"
  })));
};
export default SvgArrowDown;